import travelUi from '../assests/all imgs/Travel app UI.png';
import portfolioUi from '../assests/all imgs/Portfolio.png';
import snakeUi from '../assests/all imgs/snake game.png';
import shoppingUi from '../assests/all imgs/Shopping app UI.png';
import accordianUi from '../assests/all imgs/Dynamic Navbar.png';
import navbarUi from '../assests/all imgs/Navbar.png';
import calculatorUi from '../assests/all imgs/Calculator.png';
import tributeUi from '../assests/all imgs/Tribute Page.png';
import stylishUi from '../assests/all imgs/stylish UI.png';
import loginLogoutUi from '../assests/all imgs/redux Login Logout.png';
import reduxCrudUi from '../assests/all imgs/Redux crud.png';
import reactCartUi from '../assests/all imgs/Shopping Cart UI.png';

const projectData = [
    {
        id:1,
        imgL:navbarUi,
        pName:"Dynamic Navbar",
        disc:" This is a dynamic navbar means you do not have to add design again and again there is seperate componet which fetches the data from another file all you need to do just add data in that file. ",
        view:'https://www.youtube.com/watch?v=8VcgAZcwZSc&ab_channel=AnuragShukla',
        source:'https://github.com/loanwolf0/navbar',
        
    },
    {
        id:2,
        imgL:accordianUi,
        pName:"Accordian App demo",
        disc:" In this i add all the functionality that all other Accordian component have in various applications.",
        view:'https://accordion-anurag.netlify.app/',
        source:'https://github.com/loanwolf0/Accordian',
        
    },
    {
        id:3,
        imgL:snakeUi,
        pName:"Snake Game",
        disc:" This is a game you can play it or you can see it on youtube it stores the highest score in local database . ",
        view:'https://youtu.be/sB5IVpL3Udg',
        source:'https://github.com/loanwolf0/snake',
    },
    {
        id:4,
        imgL:tributeUi,
        pName:"Internship Tribute Page",
        disc:"I make this in my Internship program in OASIS INFOBYTE, I uses a library for image sliding but the design part is totaly made by me and all the rest things also.",
        view:'oasis-tribute.netlify.app',
        source:'https://github.com/loanwolf0/OIBSIP/tree/main/TributePage_task2',
        
    },
    {
        id:5,
        imgL:shoppingUi,
        pName:"Shopping App UI",
        disc:"This is a Shopping Website In this project i try to give it full functionality that all other shopping apps Home have, It's a Home page UI of shopping app. ",
        view:'https://shopping-anurag.netlify.app',
        source:'https://github.com/loanwolf0/Shopping_web_UI',
  
    },
    {
        id:6,
        imgL:calculatorUi,
        pName:"Internship Responsive Calculator",
        disc:"I make this in my Internship program in OASIS INFOBYTE, Here I build all the functionality by me, It has del, cancel, *,+,-,% property also it has dark mode and light mode theme",
        view:'txon-calc.netlify.app',
        source:'https://github.com/loanwolf0/OIBSIP/tree/main/Calculator_task1',
        
    },
    {
        id:7,
        imgL:stylishUi,
        pName:"Stylish Project",
        disc:"I build this projects when I am learning CSS in depth. By building this i learn many things that are basic and some are some tricky like (after) property in CSS.",
        view:'https://anurag-react-design2.netlify.app',
        source:'',
        
    },
    {
        id:8,
        imgL:loginLogoutUi,
        pName:"Redux Login Logout ",
        disc:"I build this project using REDUX v-6 in react. It basicaly taking name email and password and storing it by dispatch method and getting the name by useSelector hook.",
        view:'https://redux-login-logout-anurag.netlify.app/',
        source:'https://github.com/loanwolf0/REDUX_Login-Logout',
        
        
    },
    {
        id:9, 
        imgL:reactCartUi,
        pName:"Redux Cart ",
        disc:" It has all the functionality that all other shopping cart have, you can add items in cart and delete that items inside the cart . I used redux for this functionality.",
        view:'https://redux-cart-anurag.netlify.app/',
        source:'https://github.com/loanwolf0/REDUX_Cart',
    },
    {
        id:10,
        imgL:reduxCrudUi,
        pName:"Redux Crud Operation",
        disc:"This is website Where I impemented all crud operations CREATE,READ,UPDATE,DELETE. Here i used fekeApi to fetch data from api using id and we can edit,delete,read,create the post. ",
        view:'https://redux-crud-anurag.netlify.app/',
        source:'https://github.com/loanwolf0/Redux_CRUD',
        
    },
    {
        id:11,
        imgL:portfolioUi,
        pName:"Portfolio UI",
        disc:"By building this website I learnt many things. I also implement those things in my PORTFOLIO website.",
        view:'https://csb-qpj5yw.netlify.app/',
        source:'https://github.com/loanwolf0/portfolio',
        
    },
    {
        id:12,
        imgL:travelUi,
        pName:"Travel App UI",
        disc:"This is a Travel App, In this app you can see a Nice NAVBAR, FOOTER and MENU-ITEMS . The Website is complete responsive it is totaly fit in mobile and laptop.",
        view:'https://csb-psm4fd.netlify.app/',
        source:'https://github.com/loanwolf0/Travel-app-Ui',
        
    },
]
export default projectData